import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule as NgFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { CasButtonComponent } from './casButton';
import { CasFormFieldInputComponent } from './casFormFieldInput';
import { CasHeaderComponent } from './CasHeader';

@NgModule({
    imports: [
        CommonModule,
        NgFormsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule
    ],
    // tslint:disable-next-line: object-literal-sort-keys
    declarations: [
        CasButtonComponent,
        CasFormFieldInputComponent,
        CasHeaderComponent
    ],
    entryComponents: [
        CasButtonComponent,
        CasFormFieldInputComponent,
        CasHeaderComponent
    ],
    exports: [
        CasButtonComponent,
        CasFormFieldInputComponent,
        CasHeaderComponent
    ]
})
export class FormsModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            CasButtonComponent,
            CasFormFieldInputComponent
        ]);
    }
}
